var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sw-badge"},[_vm._t("default"),_vm._v(" "),(_vm.$slots.count)?_c('div',{staticClass:"sw-badge__count sw-text",style:({ color: _vm.inverted ? '#1f1f2e' : '#ffffff' })},[_vm._t("count")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }